<template>
    <div class="modal-mask">
        <div class="modal-content-container">
            <div class="request-providers__main-container">
                <div class="request-providers__header-container">
                    <span class="request-providers__header-title"> Fornecedores da cotação #{{ request_id }} </span>
                    <span class="material-icons request-providers__closebtn-icon" @click="closeDialog">
                        cancel
                    </span>
                </div>
                <div class="request-providers__providers-info__container">
                    <div class="request-providers__total-providers__wrapper">
                        <span class="request-providers__total-providers__title"> Total de Fornecedores - ({{ providers.length }}) </span>
                    </div>
                    <div class="request-providers__engaged-providers__wrapper">
                        <span class="request-providers__engaged-providers__title">
                            Fornecedores Engajados - ({{ get_providers_participant() }})
                        </span>
                    </div>
                    <div class="request-providers__total-entries">Quantidade de registros: {{ filterProvider(providers).length }}</div>
                    <StandardInput
                        style="margin-left: 2vw"
                        :placeholder="'Selecione o status'"
                        :action="setStatusValue"
                        :width="'25vw'"
                        :list="arraySelectStatus"
                        :type="'select'"
                    />

                    <div class="filter-toggle-container">
                        <label class="toggle-switch">
                            <input v-model="filterPrevOffered" type="checkbox" class="toggle-input" />
                            <span class="toggle-slider"></span>
                        </label>
                        <span class="toggle-label">Apenas com histórico de ofertas</span>
                    </div>

                    <div v-if="VIEW != 'LIST'" class="request-providers-back-button" @click="VIEW = 'LIST'">
                        Voltar
                    </div>
                    <button
                        v-if="showDeleteButton && isAdmin"
                        class="request-providers__delete-btn"
                        :disabled="selectedSellers.length === 0"
                        @click="deleteSelected"
                    >
                        Apagar todos selecionados
                    </button>
                </div>
                <cc-loader-full v-if="loading" />
                <div v-else-if="VIEW == 'LIST'" class="request-providers__table-container">
                    <table class="request-providers__table-wrapper">
                        <thead class="request-providers__table-thead">
                            <tr class="request-providers__table-thead-tr">
                                <th class="request-providers__table-th request-providers__table-th-provider">
                                    Fornecedor
                                </th>
                                <th class="request-providers__table-th">Vendedor / Email</th>
                                <th class="request-providers__table-th" style="width: 12%">
                                    Último Login
                                </th>
                                <th class="request-providers__table-th request-providers__table-th-cond">
                                    Cond. Pgto. / Entrega
                                </th>
                                <th class="request-providers__table-th request-order-container" @click="toggleQtd">
                                    Quantidade
                                    <span v-if="qtdOrder == 'up'" class="material-icons-outlined">
                                        arrow_upward
                                    </span>
                                    <span v-else-if="qtdOrder == 'down'" class="material-icons-outlined">arrow_downward</span>
                                    <span v-else class="material-icons-outlined">unfold_more</span>
                                </th>
                                <th class="request-providers__table-th">Fat. Min.</th>

                                <th class="request-providers__table-th request-order-container" @click="toggleOrder">
                                    Participação
                                    <span v-if="tableOrder == 'up'" class="material-icons-outlined">arrow_upward</span>
                                    <span v-else-if="tableOrder == 'down'" class="material-icons-outlined">
                                        arrow_downward
                                    </span>
                                    <span v-else class="material-icons-outlined">unfold_more</span>
                                </th>

                                <th class="request-providers__table-th">Observação</th>
                                <th class="request-providers__table-th">Status</th>
                                <th class="request-providers__table-th">Ações</th>
                            </tr>
                        </thead>
                        <tbody class="request-providers__table-tbody">
                            <tr
                                v-for="(item, index) in filterProvider(providers)"
                                :key="item.produto_id"
                                class="request-providers__table-tbody-tr"
                                :class="getSpecialBackground(index)"
                            >
                                <td class="request-providers__table-td request-providers__table-th-provider">
                                    <span class="provider-name">{{ item.seller.provider.name || "-" }}</span>
                                    <br />
                                    <cc-whatsapp :phone="item.seller.phone" />
                                </td>
                                <td class="request-providers__table-td">
                                    <span
                                        v-if="showCopy"
                                        class="material-icons request-copy-icon no-print"
                                        @click="
                                            () =>
                                                copy(
                                                    `https://novo.fornecedor.clubdacotacao.com.br/requests/${item.id}?token=${item.auth_token}`
                                                )
                                        "
                                    >
                                        file_copyv
                                    </span>
                                    {{ item.seller.name || "-" }} <br />
                                    {{ item.seller.email || "-" }}
                                </td>
                                <td class="request-providers__table-td">
                                    {{ formatDateTime(item.seller.last_login) }}
                                </td>
                                <td class="request-providers__table-td">
                                    {{ item.delivery ? item.delivery.form : "-" }} <br />
                                    {{ item.delivery ? formatDate(item.delivery.date) : "-" }}
                                </td>
                                <td class="request-providers__table-td">
                                    {{ item.qtdCotacao || "--" }}
                                </td>
                                <td class="request-providers__table-td">
                                    {{
                                        item.delivery
                                            ? item.delivery.minimum_billing.toLocaleString("pt-BR", {
                                                  currency: "BRL",
                                                  style: "currency",
                                                  minimumFractionDigits: 2,
                                              })
                                            : "-"
                                    }}
                                </td>
                                <td class="request-providers__table-td">
                                    <div
                                        v-if="item.seller_client && item.seller_client.participation"
                                        :class="getPercent(item.seller_client.participation)"
                                    >
                                        {{ (item.seller_client.participation * 100).toFixed(2) + " %" }}
                                    </div>
                                </td>
                                <td class="request-providers__table-td">
                                    <span
                                        v-if="item.delivery && item.delivery.obs"
                                        class="material-icons-outlined"
                                        :title="item.delivery.obs"
                                        >info</span
                                    >
                                </td>
                                <td class="request-providers__table-td">
                                    <div class="provider-cell-container">
                                        <span :title="`${item.reason ? item.reason.descricao : ''}`">
                                            <div v-if="item.status == 'NOT_TYPED'" class="table-not-typed">
                                                Não digitada
                                            </div>
                                            <div v-if="item.status == 'TYPED'" class="table-typed">
                                                Digitada
                                            </div>
                                            <div v-if="item.status == 'FROZEN'" class="table-freezed">
                                                CONGELADA
                                            </div>
                                            <div v-if="item.status == 'ORDERED'" class="table-created">
                                                Pedido Gerado
                                            </div>
                                            <div v-if="item.status == 'NOT_OFFERED'" class="table-nooffer">
                                                SEM OFERTA
                                            </div>
                                            <div v-if="item.status == 'NOT_ORDERED'" class="table-noorder">
                                                SEM PEDIDO
                                            </div>

                                            <span
                                                v-if="item.prev_offered_products_count !== undefined"
                                                class="info-circle info-circle-prev clickable"
                                                :title="`Produtos ofertados anteriormente: ${item.prev_offered_products_count}`"
                                                @click="open_seller_offers(item)"
                                            >
                                                {{ item.prev_offered_products_count }}
                                            </span>
                                            <span
                                                v-if="item.offered_products_count !== undefined"
                                                class="info-circle info-circle-current"
                                                :title="`Produtos ofertados nesta cotação: ${item.offered_products_count}`"
                                            >
                                                {{ item.offered_products_count }}
                                            </span>
                                            <span
                                                class="material-icons-outlined viewed-check-icon"
                                                :class="{
                                                    'viewed-check-active': item.viewed_at,
                                                    'viewed-check-inactive': !item.viewed_at,
                                                }"
                                                :title="
                                                    item.viewed_at ? `Visualizado em: ${formatDateTime(item.viewed_at)}` : 'Não visualizado'
                                                "
                                            >
                                                done_all
                                            </span>
                                        </span>
                                    </div>
                                </td>
                                <td class="request-providers__table-td">
                                    <div class="actions-cell-container">
                                        <span
                                            title="Remover da cotação"
                                            class="material-icons-outlined table-icon-delete"
                                            @click="remove(item)"
                                            >delete</span
                                        >
                                        <span
                                            title="Histórico da digitação"
                                            class="material-icons-outlined table-icon-list"
                                            @click="open_participation(item)"
                                            >list_alt</span
                                        >
                                        <span
                                            v-if="item.seller_client && item.seller_client.new_request_notification_enabled"
                                            :title="notifyingSellers[item.seller.id] ? 'Enviando...' : 'Reenviar notificação'"
                                            class="material-icons-outlined table-icon-notify"
                                            :class="{
                                                'icon-loading': notifyingSellers[item.seller.id],
                                            }"
                                            @click="resendNotification(item)"
                                        >
                                            {{ notifyingSellers[item.seller.id] ? "sync" : "notifications_active" }}
                                        </span>
                                        <input
                                            v-if="isAdmin && (!item.seller_client || !item.seller_client.participation)"
                                            v-model="selectedSellers"
                                            type="checkbox"
                                            :value="item.seller.id"
                                            class="request-providers__checkbox"
                                            @change="updateDeleteButtonVisibility"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <SellerOffers
                    v-else-if="VIEW == 'OFFERS'"
                    :is-sellers-management="true"
                    :request_id="current_request.id"
                    :show_offered_products="true"
                    :seller_id="request_seller.seller.id"
                    :for_id="request_seller.seller.provider.id"
                />
                <SellerParticipation
                    v-else-if="VIEW == 'PARTICIPATION'"
                    :selected-status="selectedStatus"
                    :request_id="request_id"
                    :request_seller="current_request_seller"
                />
            </div>
        </div>
    </div>
</template>
<script>
import QuotationService from "@/services/QuotationService";
import RequestService from "@/services/v3/request.service";
import SellerService from "@/services/v3/providers/seller.service";
import { mapState } from "vuex";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import StandardInput from "@/components/ui/inputs/StandardInput.vue";
import SellerParticipation from "./components/seller-participation.partial.vue";
import SellerOffers from "@/modals/providers/sellers/_offers.partial";

export default {
    components: { SellerParticipation, StandardInput, SellerOffers },
    mixins: [loaderMixin],
    props: ["request_id", "closeDialog"],
    data() {
        return {
            VIEW: "LIST",
            loading: false,
            service: new QuotationService(),
            requestService: new RequestService(),
            seller_svc: new SellerService(),
            providers: [],
            current_request_seller: undefined,
            current_request: undefined,
            request_seller: undefined,
            isSellersManagement: false,
            tableOrder: undefined,
            qtdOrder: undefined,
            modal: {
                title: `Fornecedores da Cotação #${this.request_id}`,
                unpermitted_message: "Aceite o termo de consentimento para continuar.",
                permitted: true,
                cancel_text: "voltar",
                nobackbutton: false,
                style: {
                    width: "90%",
                },
            },
            arraySelectStatus: [
                { text: "Todos", value: undefined },
                { text: "Sem oferta", value: "NOT_OFFERED" },
                { text: "Não digitada", value: "NOT_TYPED" },
                { text: "Digitada", value: "TYPED" },
                { text: "Congelada", value: "FROZEN" },
                { text: "Pedido gerado", value: "ORDERED" },
                { text: "Sem pedido", value: "NOT_ORDERED" },
            ],
            selectedStatus: undefined,
            selectedSellers: [],
            showDeleteButton: false,
            showCopy: true,
            filterPrevOffered: false,
            notifyingSellers: {},
        };
    },
    computed: {
        ...mapState(["statuses", "user"]),

        isAdmin() {
            const user = this.user || {};
            if (user.perms) {
                const isAdmin = user.perms.some((perm) => perm.resource === "ADMIN" && perm.action === "MANAGE");
                return isAdmin;
            }
            if (user.group) {
                const isAdmin = user.group.includes("ADMINISTRADOR");
                return isAdmin;
            }
            return false;
        },
    },
    created() {
        this.load_providers();
        window.addEventListener("keydown", this.handlekeydown);
    },
    beforeDestroy() {
        window.removeEventListener("keydown", this.handlekeydown);
    },
    methods: {
        handlekeydown(e) {
            if (e.key === "Escape") {
                this.close();
            }
        },
        updateDeleteButtonVisibility() {
            this.showDeleteButton = this.providers.some((item) => !item.seller_client || !item.seller_client.participation);
        },
        deleteSelected() {
            if (this.selectedSellers.length === 0) return;

            this.confirm_action({
                message: `Confirma remoção de ${this.selectedSellers.length} vendedor(es)?`,
                subtitle: "Os vendedores serão removidos da cotação e do cliente!",
                callback: () => {
                    this.present_loader(`Removendo ${this.selectedSellers.length} vendedores...`);

                    const removeSellerPromises = this.selectedSellers.map((sellerId) =>
                        this.requestService.remove_seller(this.request_id, sellerId)
                    );

                    Promise.all(removeSellerPromises)
                        .then(() => {
                            const deactivateClientPromises = this.selectedSellers.map((sellerId) => {
                                const item = this.providers.find((p) => p.seller.id === sellerId);
                                if (item && item.seller_client) {
                                    return this.seller_svc.deactivate_client(sellerId, item.seller_client.client_id);
                                }
                                return Promise.resolve();
                            });
                            return Promise.all(deactivateClientPromises);
                        })
                        .then(() => this.load_providers())
                        .then(() => {
                            this.selectedSellers = [];
                            this.showDeleteButton = false;
                            this.dismiss_loader();

                            this.show_success_modal({
                                title: "Sucesso!",
                                message: `Vendedor(es) removido(s) com sucesso.`,
                                confirmText: "OK",
                                showCancelButton: false,
                            });
                        })
                        .catch((error) => {
                            this.dismiss_loader();
                            console.error("Erro ao remover vendedores:", error);
                            this.show_error_modal({
                                title: "Erro",
                                message: "Ocorreu um erro ao remover os vendedores. Por favor, tente novamente.",
                                confirmText: "Entendi",
                                showCancelButton: false,
                            });
                        });
                },
            });
        },
        show_success_modal(options) {
            this.$swal({
                icon: "success",
                title: options.title,
                text: options.message,
                confirmButtonText: options.confirmText,
                showCancelButton: options.showCancelButton || false,
                customClass: {
                    container: "sweet-modal-container",
                },
            });
        },

        show_error_modal(options) {
            this.$swal({
                icon: "error",
                title: options.title,
                text: options.message,
                confirmButtonText: options.confirmText,
                showCancelButton: options.showCancelButton || false,
                customClass: {
                    container: "sweet-modal-container",
                },
            });
        },
        filterProvider(providers) {
            let filtered = providers;

            // Filter by previous offered products if toggle is on
            if (this.filterPrevOffered) {
                filtered = filtered.filter((item) => item.prev_offered_products_count && item.prev_offered_products_count > 0);
            }

            // Filter by status if selected
            if (this.selectedStatus) {
                const resp = [];
                filtered.forEach((item) => {
                    if (item.status == this.selectedStatus) resp.push(item);
                });
                return resp;
            }

            return filtered;
        },
        toggleQtd() {
            if (this.qtdOrder != "down") this.qtdOrder = "down";
            else this.qtdOrder = "up";
            if (this.qtdOrder == "up")
                this.providers = this.providers.sort((a, b) => {
                    if (a.qtdCotacao && b.qtdCotacao) return a.qtdCotacao - b.qtdCotacao;
                });
            else if (this.qtdOrder == "down")
                this.providers = this.providers.sort((a, b) => {
                    if (a.qtdCotacao && b.qtdCotacao) return b.qtdCotacao - a.qtdCotacao;
                });
            this.$forceUpdate();
        },
        toggleOrder() {
            if (this.tableOrder != "down") this.tableOrder = "down";
            else this.tableOrder = "up";
            if (this.tableOrder == "up")
                this.providers = this.providers.sort((a, b) => {
                    if (a.seller_client && b.seller_client) return a.seller_client.participation - b.seller_client.participation;
                });
            else if (this.tableOrder == "down")
                this.providers = this.providers.sort((a, b) => {
                    if (a.seller_client && b.seller_client) return b.seller_client.participation - a.seller_client.participation;
                });
            this.$forceUpdate();
        },
        setStatusValue(value) {
            this.selectedStatus = value;
        },
        getPercent(value) {
            if (value <= 0.3) return "table-not-typed";
            else if (value >= 0.7) return "table-typed";
            else return "percent-orange";
        },
        open_participation(seller) {
            this.current_request_seller = seller;
            this.VIEW = "PARTICIPATION";
        },
        open_seller_offers(seller) {
            this.request_seller = seller;
            this.current_request = { id: this.request_id };
            this.VIEW = "OFFERS";
        },
        formatDate(date) {
            return date.split("-")[2] + "/" + date.split("-")[1] + "/" + date.split("-")[0];
        },
        formatDateTime(dateTime) {
            if (!dateTime) return "-";
            const date = new Date(dateTime);
            const day = String(date.getDate()).padStart(2, "0");
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            return `${day}/${month}/${year} às ${hours}:${minutes}`;
        },
        close() {
            this.$emit("close");
        },
        remove(request_seller) {
            this.confirm_action({
                message: "Confirma remoção do vendedor?",
                subtitle: "O vendedor será removido da cotação e do cliente!",
                callback: () => {
                    this.present_loader("Removendo vendedor da cotação...");
                    return this.requestService
                        .remove_seller(this.request_id, request_seller.seller.id)
                        .then(() => this.dismiss_loader())
                        .then(() => {
                            this.present_loader("Removendo vendedor do cliente...");
                            this.seller_svc
                                .deactivate_client(request_seller.seller.id, request_seller.seller_client.client_id)
                                .then(this.load_providers)
                                .then(() => this.dismiss_loader());
                        });
                },
            });
        },
        load_providers() {
            this.loading = true;
            return this.requestService
                .sellers(this.request_id)
                .then((request) => {
                    this.providers = request.data;
                    this.updateDeleteButtonVisibility();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        get_providers_participant() {
            const status = ["NÃO DIGITADA", "NÃO DIGITADO", "AGUARDANDO CONFIRMACAO", "NOT_TYPED"];
            return this.providers.filter((p) => !status.includes(p.status)).length;
        },
        getSpecialBackground(index) {
            if (index % 2 != 0) return "page-table-line-special";
        },
        copy(value) {
            console.log(value);
            this.$swal.fire("Link Copiado");
            navigator.clipboard.writeText(value);
        },
        resendNotification(item) {
            if (this.notifyingSellers[item.seller.id]) return;

            this.$set(this.notifyingSellers, item.seller.id, true);

            this.requestService
                .notify_seller_webhook(this.request_id, item.seller.id)
                .then(() => {
                    this.$swal.fire({
                        icon: "success",
                        title: "Sucesso!",
                        text: "Notificação reenviada com sucesso.",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                })
                .catch((error) => {
                    console.error("Erro ao reenviar notificação:", error);
                    this.$swal.fire({
                        icon: "error",
                        title: "Erro",
                        text: "Não foi possível reenviar a notificação.",
                    });
                })
                .finally(() => {
                    this.$set(this.notifyingSellers, item.seller.id, false);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.request-providers__checkbox {
    margin-left: 8px;
    cursor: pointer;
    width: 16px;
}

.request-providers__delete-btn {
    margin-left: auto;
    padding: 8px 16px;
    background-color: var(--primary-color);
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;

    &:hover {
        background-color: #cc0000;
    }

    &:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
    }
}

.modal-mask {
    position: fixed;
    z-index: 4;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
}

.modal-content-container {
    background-color: white;
    min-width: 50vw;
    border-radius: 12px;
}

.request-providers__main-container {
    width: 115vw;
    height: 100vh;
}

.request-providers__header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-radius: 10px 10px 0px 0px;
    background-color: var(--primary-color);
}

.request-providers__header-title {
    color: #ffffff;
    letter-spacing: -2%;
    font-weight: 500;
    font-size: 32px;
}

.request-providers__closebtn-icon {
    color: #ffffff;
    font-size: 30px;
    cursor: pointer;
}

.request-providers__providers-info__container {
    display: flex;
    align-items: center;
    margin: 20px;
}

.request-providers__total-providers__wrapper {
    background-color: var(--primary-color) 1a;
    margin-right: 3vw;
    padding: 6px;
    border-radius: 8px;
}

.request-providers__total-providers__title {
    color: var(--primary-color);
    font-weight: 300;
    font-size: 20px;
}

.request-providers__total-entries {
    background-color: rgb(204, 227, 235);
    color: rgb(79, 79, 247);
    font-size: 20px;
    font-weight: 300;
    padding: 6px;
    border-radius: 8px;
    margin-left: 2vw;
}

.filter-toggle-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 2vw;
}

.toggle-switch {
    position: relative;
    display: inline-block;
    width: 51px;
    height: 31px;
    margin: 0;
}

.toggle-input {
    opacity: 0;
    width: 0;
    height: 0;
}

.toggle-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.3s;
    border-radius: 31px;
}

.toggle-slider:before {
    position: absolute;
    content: "";
    height: 27px;
    width: 27px;
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: 0.3s;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-input:checked + .toggle-slider {
    background-color: #34c759;
}

.toggle-input:focus + .toggle-slider {
    box-shadow: 0 0 1px #34c759;
}

.toggle-input:checked + .toggle-slider:before {
    transform: translateX(20px);
}

.toggle-label {
    font-size: 14px;
    color: #605f5f;
    font-weight: 400;
    user-select: none;
}

.request-providers__engaged-providers__wrapper {
    background-color: #2acd721a;
    padding: 6px;
    border-radius: 8px;
}

.request-providers__engaged-providers__title {
    color: #30aa4c;
    font-weight: 300;
    font-size: 20px;
}

.table-icon-delete {
    color: lightcoral;
    cursor: pointer;
}

.table-icon-list {
    color: var(--primary-color);
    cursor: pointer;
}

.table-icon-notify {
    color: #f0ad4e;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.1);
    }
}

.icon-loading {
    animation: spin 1s linear infinite;
    pointer-events: none;
    opacity: 0.7;
}

@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.percent-orange {
    background-color: lightsalmon;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    cursor: default;
}

.table-not-typed {
    background-color: lightcoral;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    min-width: 8rem;
    cursor: default;
}

.table-typed {
    background-color: lightgreen;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    min-width: 8rem;
    cursor: default;
}

.table-freezed {
    background-color: gray;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    min-width: 8rem;
}

.table-created {
    background-color: lightblue;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    min-width: 8rem;
}

.table-nooffer {
    outline: 1px solid gray;
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    min-width: 8rem;
    cursor: help;
}

.table-noorder {
    background-color: rgb(178, 230, 206);
    outline: 1px solid rgb(178, 230, 206);
    font-weight: bold;
    text-transform: uppercase;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    min-width: 8rem;
}

.request-providers__table-container {
    margin: 20px;
    overflow-y: auto;
    max-height: 72vh;
}

.request-providers__table-thead-tr {
    background-color: #fffefc;
    border: 0.5px solid #e5e5e5;
    color: #605f5f;
    font-size: 14px;
    font-weight: 400;
}

.request-providers__table-th {
    font-size: 14px;
    font-weight: 600;
}

table {
    th {
        border-bottom: none;
    }
}

.request-providers__table-td {
    color: #605f5f;
    font-size: 14px;
    font-weight: 300;
}

.request-providers__table-th-provider {
    width: 22%;
}

.provider-cell-container {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: default;
}

.info-circle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    font-size: 11px;
    font-weight: 600;
    color: white;
    flex-shrink: 0;
    cursor: help;
}

.info-circle-prev {
    background-color: #6c757d;
}

.info-circle.clickable {
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-circle.clickable:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.info-circle-current {
    background-color: var(--primary-color);
}

.viewed-check-icon {
    font-size: 18px;
    margin-left: 4px;
    cursor: help;
    transition: color 0.2s ease;
}

.viewed-check-active {
    color: #25b8d3;
}

.viewed-check-inactive {
    color: #999999;
}

.provider-name {
    flex: 1;
}

.request-providers__table-th-date {
    width: 7%;
}

.request-providers__table-th-cond {
    width: 15%;
}

.page-table-line-special {
    background: #f7f7f7;
}

.request-order-container {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.request-providers-back-button {
    margin-left: auto;
    margin-right: 2vw;
    color: var(--primary-color);
    outline: var(--primary-color) 1px solid;
    padding: 0.5vh 1vw;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
        background-color: var(--primary-color);
        color: white;
    }
}

@media only screen and (max-width: 750px) {
    .request-providers__header-title {
        font-size: 24px;
    }

    .request-providers__total-providers__title {
        font-size: 16px;
    }

    .request-providers__engaged-providers__title {
        font-size: 16px;
    }

    .request-providers__table-container {
        height: 70vh;
    }
}

@media print {
    body > *:not(.request-providers__table-wrapper):not(.request-print-logo):not(.request-print-title) {
        display: none !important;
    }

    .no-print {
        display: none !important;
    }
}

.actions-cell-container {
    display: flex;
    align-items: center;
    gap: 5px;
}

.request-copy-icon {
    cursor: pointer;
    font-size: 1.5em;
}

@import "./request-providers.modal";
</style>
